import { render, staticRenderFns } from "./organization-event-card.vue?vue&type=template&id=30e86f90&scoped=true&"
import script from "./organization-event-card.vue?vue&type=script&lang=js&"
export * from "./organization-event-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e86f90",
  null
  
)

export default component.exports